import { applyMiddleware } from 'redux';
import jira from 'src/services/jira/middleware';
import libConfigurator from 'src/services/libConfigurator/middleware';
import linkedIncident from 'src/services/linkedIncident/middleware';
import session from 'src/services/session/middleware';

const mainMiddleware = applyMiddleware(
  jira,
  session,
  libConfigurator,
  linkedIncident,
);

export default mainMiddleware;
